
import { Vue } from "vue-class-component";

export default class CustomProcess extends Vue {}
